import { CVC_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validateCVC = (cvc: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };


  const isValid = CVC_VALIDATOR.test(String(cvc));
  if (!isValid) {
    result.error = 'Invalid CVC';
    result.isValid = false;
  }

  return result;
};
